const API_URL = "/api/partizi";

export const partiziApi = {
  create: async (datePartida) => {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(datePartida),
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.error || "Eroare la server");
    return result;
  },
};
